import { FunctionComponent } from "react";
import { SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

import * as Styled from "./styles";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";

import { CarouselSwiperItemData } from "./constant";
import CarouselSwiperItem from "./CarouselSwiperItem";

interface CarouselSwiperProps {
  slidesInfo: CarouselSwiperItemData[];
  showQuote?: boolean;
}

const CarouselSwiper: FunctionComponent<CarouselSwiperProps> = ({
  slidesInfo,
  showQuote = true,
}: CarouselSwiperProps) => {
  return (
    <Styled.SwiperDiv
      direction="vertical"
      slidesPerView={1}
      autoplay={{
        delay: 8000,
        disableOnInteraction: false,
      }}
      modules={[Autoplay, Pagination]}
      speed={1000}
      loop
      pagination={{
        clickable: true,
      }}
      $showQuote={showQuote}
    >
      {slidesInfo.map((slide) => (
        <SwiperSlide key={slide.title} className="carousel-swiper-slide">
          <Styled.SwiperSlideWrapper>
            <Styled.SwiperSlideChildWrapper>
              <CarouselSwiperItem {...slide} showQuote={showQuote} />
            </Styled.SwiperSlideChildWrapper>
          </Styled.SwiperSlideWrapper>
        </SwiperSlide>
      ))}
    </Styled.SwiperDiv>
  );
};

export default CarouselSwiper;
